import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {map, switchMap} from 'rxjs';
import {NotificationService} from 'src/app/services/notification.service';
import {AppState} from '../../reducers';
import * as fromActions from './media-image.actions';
import * as fromGraphql from './media-image.graphql';


@Injectable()
export class MediaImageEffects {
  uploadLandingBase64File$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.uploadLandingBase64File),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPLOAD_LANDING_BASE64_FILE,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(
                fromActions.upsertMediaImage({ mediaImage: result?.data })
              );
              this.notificationService.successMessage('Created Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });



  deleteLandingBase64File$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.deleteLandingBase64File),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_MEDIA_IMAGE,
        variables: {
          imageUniqueId: action?.imageUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteMediaImage({ id: action.id }));
              this.notificationService.successMessage('Deleted Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getMediaImages$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getMediaImages),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_MEDIA_IMAGES,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching data'),
        map(({ data }: any ) => {

          if (data) {
            const result: any = data?.getMediaImages;
            result?.response?.status ? this.store.dispatch(
              fromActions.loadMediaImages({ mediaImages: result?.data })
            )
            : []
          }
        })
      );
    })
  ), { dispatch: false });

  citizenGetMediaImages$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetMediaImages),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.CITIZEN_GET_MEDIA_IMAGES,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching data'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = data?.citizenGetMediaImages
            result?.response?.status ? this.store.dispatch(
              fromActions.loadMediaImages({ mediaImages: result?.data })
            ) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
  ) {}
}
